import React, { Fragment } from "react";

const RenderOddsSkyWeb = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  active,
  betType,
  index,
  disabeLay,
  indexObject,
}) => {
  const chamakBack = (index) => {
    return oldBack?.length > 0
      ? odds_back?.[index]?.rt != oldBack[index]?.rt ||
          odds_back?.[index]?.bv != oldBack[index]?.bv
      : false;
  };
  const chamakLay = (index) => {
    return oldLay?.length > 0
      ? odds_lay?.[index]?.rt != oldLay[index]?.rt ||
          odds_lay?.[index]?.bv != oldLay[index]?.bv
      : false;
  };
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <Fragment>
      {disabelBack ? (
        <td id="closed" colSpan={3} className="suspend">
          <span>Suspend</span>
        </td>
      ) : (
        <Fragment>
          <td
            onClick={(e) => {
              if (!disabelBack && ms == 1) {
                if (!checkDisabled(odds_back?.[0]?.rt)) {
                  handelChange(
                    odds_back?.[0],
                    "back",
                    item?.RunnerName,
                    item,
                    e,
                    0
                  );
                }
              }
            }}
            id="back_3"
            className={`back-3 ${chamakBack(0) ? "spark" : ""} ${
              active && betType == "back" && indexObject == 0 ? "select" : ""
            }`}
          >
            <a>
              {odds_back?.[0]?.rt || ""}
              <span>{odds_back?.[0]?.bv || ""}</span>
            </a>
          </td>

          <td
            onClick={(e) => {
              if (!disabelBack && ms == 1) {
                if (!checkDisabled(odds_back?.[1]?.rt)) {
                  handelChange(
                    odds_back?.[1],
                    "back",
                    item?.RunnerName,
                    item,
                    e,
                    1
                  );
                }
              }
            }}
            id="back_2"
            className={`back-2 ${chamakBack(1) ? "spark" : ""} ${
              active && betType == "back" && indexObject == 1 ? "select" : ""
            }`}
          >
            <a>
              {odds_back?.[1]?.rt || ""}
              <span>{odds_back?.[1]?.bv || ""}</span>
            </a>
          </td>

          <td
            onClick={(e) => {
              if (!disabelBack && ms == 1) {
                if (!checkDisabled(odds_back?.[2]?.rt)) {
                  handelChange(
                    odds_back?.[2],
                    "back",
                    item?.RunnerName,
                    item,
                    e,
                    2
                  );
                }
              }
            }}
            id="back_1"
            className={`back-1 ${chamakBack(2) ? "spark" : ""} ${
              active && betType == "back" && indexObject == 2 ? "select" : ""
            }`}
          >
            <a>
              {odds_back?.[2]?.rt || ""}
              <span>{odds_back?.[2]?.bv || ""}</span>
            </a>
          </td>
        </Fragment>
      )}

      {disabeLay ? (
        <td id="closed" colSpan={3} className="suspend">
          <span>Suspend</span>
        </td>
      ) : (
        <Fragment>
          <td
            onClick={(e) => {
              if (!disabelLay && ms == 1) {
                if (!checkDisabled(odds_lay?.[0]?.rt)) {
                  handelChange(
                    odds_lay?.[0],
                    "lay",
                    item?.RunnerName,
                    item,
                    e,
                    0
                  );
                }
              }
            }}
            id="lay_1"
            className={`lay-1 ${chamakLay(0) ? "spark" : ""} ${
              active && betType == "lay" && indexObject == 0 ? "select" : ""
            }`}
          >
            <a>
              {odds_lay?.[0]?.rt || ""}
              <span>{odds_lay?.[0]?.bv || ""}</span>
            </a>
          </td>
          <td
            onClick={(e) => {
              if (!disabelLay && ms == 1) {
                if (!checkDisabled(odds_lay?.[1]?.rt)) {
                  handelChange(
                    odds_lay?.[1],
                    "lay",
                    item?.RunnerName,
                    item,
                    e,
                    1
                  );
                }
              }
            }}
            id="lay_2"
            className={`lay-2 ${chamakLay(1) ? "spark" : ""}${
              active && betType == "lay" && indexObject == 1 ? "select" : ""
            }`}
          >
            <a>
              {odds_lay?.[1]?.rt || ""}
              <span>{odds_lay?.[1]?.bv || ""}</span>
            </a>
          </td>
          <td
            onClick={(e) => {
              if (!disabelLay && ms == 1) {
                if (!checkDisabled(odds_lay?.[2]?.rt)) {
                  handelChange(
                    odds_lay?.[2],
                    "lay",
                    item?.RunnerName,
                    item,
                    e,
                    2
                  );
                }
              }
            }}
            id="lay_3"
            className={`lay-3 ${chamakLay(2) ? "spark" : ""} ${
              active && betType == "lay" && indexObject == 2 ? "select" : ""
            }`}
          >
            <a>
              {odds_lay?.[2]?.rt || ""}
              <span>{odds_lay?.[2]?.bv || ""}</span>
            </a>
          </td>{" "}
        </Fragment>
      )}
    </Fragment>
  );
};

export default RenderOddsSkyWeb;
